import { createSelector } from "reselect";
import { selectPrepJob } from "./selectPrepJob";

export const selectHasPrepV2 = createSelector(selectPrepJob, (prepJob): boolean => {
  return Boolean(prepJob && prepJob.prepTypes.length > 0);
});
